import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

export type IconCheckCircleProps = {
  theme?: IconTheme;
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

interface IconCheckCircleSvgProps {
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

function DefaultSvg({ className, title }: IconCheckCircleSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M9.05331 2.66663H6.94665C5.4579 2.66663 4.03012 3.25803 2.97742 4.31073C1.92472 5.36344 1.33331 6.79121 1.33331 8.27996V8.38663C1.33331 9.87537 1.92472 11.3031 2.97742 12.3559C4.03012 13.4086 5.4579 14 6.94665 14H9.05331C9.79047 14 10.5204 13.8548 11.2014 13.5727C11.8825 13.2906 12.5013 12.8771 13.0225 12.3559C13.5438 11.8346 13.9573 11.2158 14.2394 10.5348C14.5215 9.85371 14.6666 9.12378 14.6666 8.38663V8.27996C14.6666 7.54281 14.5215 6.81287 14.2394 6.13183C13.9573 5.45079 13.5438 4.83198 13.0225 4.31073C12.5013 3.78949 11.8825 3.37601 11.2014 3.09392C10.5204 2.81182 9.79047 2.66663 9.05331 2.66663ZM7.01998 10.9333L4.58665 8.49996L5.53331 7.55996L7.01998 9.04663L10.4666 5.59996L11.4066 6.53996L7.01998 10.9333Z" />
    </svg>
  );
}

function OutlineSvg({ className, title }: IconCheckCircleSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M7.01998 10.3667L4.70665 8.05337L5.41331 7.33337L7.01998 8.93337L10.5866 5.37337L11.2933 6.08004L7.01998 10.3667ZM9.05331 3.33337H6.94665C5.72311 3.33337 4.54969 3.81942 3.68453 4.68459C2.81936 5.54976 2.33331 6.72318 2.33331 7.94671V8.05337C2.33331 9.27691 2.81936 10.4503 3.68453 11.3155C4.54969 12.1807 5.72311 12.6667 6.94665 12.6667H9.05331C9.65914 12.6667 10.259 12.5474 10.8188 12.3155C11.3785 12.0837 11.887 11.7439 12.3154 11.3155C12.7438 10.8871 13.0836 10.3785 13.3155 9.81882C13.5473 9.2591 13.6666 8.6592 13.6666 8.05337V7.94671C13.6666 6.72318 13.1806 5.54976 12.3154 4.68459C11.4503 3.81942 10.2768 3.33337 9.05331 3.33337ZM9.05331 2.33337C9.79047 2.33337 10.5204 2.47857 11.2014 2.76066C11.8825 3.04276 12.5013 3.45623 13.0225 3.97748C13.5438 4.49873 13.9573 5.11754 14.2394 5.79858C14.5215 6.47962 14.6666 7.20955 14.6666 7.94671V8.05337C14.6666 8.79053 14.5215 9.52046 14.2394 10.2015C13.9573 10.8825 13.5438 11.5014 13.0225 12.0226C12.5013 12.5438 11.8825 12.9573 11.2014 13.2394C10.5204 13.5215 9.79047 13.6667 9.05331 13.6667H6.94665C5.4579 13.6667 4.03012 13.0753 2.97742 12.0226C1.92472 10.9699 1.33331 9.54212 1.33331 8.05337V7.94671C1.33331 6.45796 1.92472 5.03019 2.97742 3.97748C4.03012 2.92478 5.4579 2.33337 6.94665 2.33337H9.05331Z" />
    </svg>
  );
}

export default function IconCheckCircle({
  theme = "black",
  style = "filled",
  className,
  title,
}: IconCheckCircleProps) {
  const themeClassname = THEME_COLOR[theme];
  const Variant = style === "outline" ? OutlineSvg : DefaultSvg;

  return <Variant title={title} className={cn(className, themeClassname)} />;
}
